<template>
  <div class="err-pg">
    <div class="container">
      <div class="position">
        <div class="bg-white p-20">
          <div class="err-body">
            <Error401 v-if="this.$route.params.status === 401 || this.$route.params.status === '401'"/>
            <Error403 v-if="this.$route.params.status === 403"/>
            <Error404 v-if="this.$route.params.status === 404 || this.$route.params.status === '404'"/>
            <Error400 v-if="this.$route.params.status === 400 || this.$route.params.status === '400'"/>
            <Error500 v-if="this.$route.params.status === 500"/>
          </div>
          <div class="err-footer">
            <router-link
              :to="$i18nRoute({ name: 'home' })"
            >{{ $t("Главная") }}
            </router-link>
            <router-link
              :to="$i18nRoute({ name: 'profile' })"
            >{{ $t("Профиль") }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Error401 from '@/components/error/Error401'
import Error403 from '@/components/error/Error403'
import Error404 from '@/components/error/Error404'
import Error400 from '@/components/error/Error400'
import Error500 from '@/components/error/Error500'

export default {
  components: {
    Error401,
    Error403,
    Error404,
    Error400,
    Error500
  },
  created() {
    this.scrollToTop()
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
